import React from "react";



import useQuote from "../../hooks/useQuote";
import useStock from "../../hooks/useStock";
import { toRatio, upDownMarker } from "../../libraries";
import { Change } from "../../types"


export default function StockSummary() {
  const { contents: stock } = useStock()
  const quote = useQuote()

  return (
    <>
      <div className="txt">
        <strong>{stock.name}</strong>
        <p>{stock.symbolCode}</p>
        <em>{stock.market}</em>
      </div>
      <div className="num">
        <strong>{quote?.tradePrice.toLocaleString()}</strong>

        <p className={isUpDown(quote?.change || stock.change)}>
          {quote?.changePrice || stock.changePrice}
          <em>
            {upDownMarker(quote?.change || stock.change)}
            {toRatio(quote?.changeRate || stock.changeRate)}%
          </em>
        </p>
      </div>
    </>
  )
}

function isUpDown(change?: Change) {
  switch (change) {
    case 'UPPER_LIMIT':
    case 'RISE':
      return 'up'
    case 'FALL':
    case 'LOWER_LIMIT':
      return 'down'
    default:
      return ''
  }
}
